import { ThemeContext as e } from "@filbert-js/theming";
import { TYPES_GLOBAL as r, TYPES_STYLES as t, CLASS_PREFIX as n, IS_STYLED_COMPONENT as a, TYPE as o, TYPES_KEYFRAMES as c, RAW as u, LABEL_PREFIX as i, SOURCE_ORDER as f } from "@filbert-js/types";
import l from "react";
import { __sheet as s } from "@filbert-js/style-sheet-context";
var v = 0,
    m = l.memo(function (e) {
  var t = e.styles;
  return function (e, t) {
    s.createGlobalStyles(e, t), l.useEffect(function () {
      s.createGlobalStyles(e, t);
    }, [t, e]), l.useEffect(function () {
      return function () {
        return s.removeStyles(e, r);
      };
    }, [e]);
  }(l.useState(function () {
    return "global-" + ++v;
  })[0], t), null;
}),
    p = {};

function y(e, r, t) {
  return function () {
    var i,
        f = function (e) {
      for (var r = this, t = [], n = arguments.length - 1; n-- > 0;) {
        t[n] = arguments[n + 1];
      }

      var u = [];
      return [e.reduce(function (e, n, i) {
        return "" + e + function (e, r, t) {
          var n = t;
          return t[o] === c ? (e.push(t), n = t) : t[a] ? n = "." + t.label : "function" == typeof t && (n = t(r)), n;
        }(u, r, t[i - 1]) + n;
      }), u];
    }.apply(t, arguments),
        l = f[0],
        s = f[1],
        v = function (e, r) {
      void 0 === r && (r = n);
      var t = p[e] || 0;

      if (!t) {
        for (var a = 0; a < e.length; a++) {
          t = (t << 5) - t + e.charCodeAt(a), t |= 0;
        }

        p[e] = t;
      }

      return r + "-" + t;
    }(l, r || e);

    return (i = {})[o] = e, i[u] = [l, s], i.toString = function () {
      return v;
    }, i;
  };
}

var b = 1;

function d(r, n) {
  return void 0 === n && (n = {}), function () {
    var o = arguments;

    function c(i, v) {
      var m,
          p = l.useContext(e),
          b = y(void 0, n.label, Object.assign({}, i, {
        theme: p
      })).apply(null, o),
          d = b[u],
          h = d[0],
          S = d[1],
          g = b.toString();
      !function (e, r, n, a, o) {
        var c = l.useRef();
        e.forEach(function (e) {
          return s.createKeyframes(e);
        }), s.createStyles(r, n, a, o), c.current = r, l.useEffect(function () {
          var e = r;
          return function () {
            e !== c.current && s.removeStyles(e, t);
          };
        }, [r]), l.useEffect(function () {
          return function () {
            return s.removeStyles(c.current, t);
          };
        }, []);
      }(S, g, h, i[f], c.label);
      var j = i.className;
      void 0 === j && (j = "");

      var E = i.as,
          O = i.children,
          N = function (e, r) {
        var t = {};

        for (var n in e) {
          Object.prototype.hasOwnProperty.call(e, n) && -1 === r.indexOf(n) && (t[n] = e[n]);
        }

        return t;
      }(i, ["className", String(f), "as", "children"]),
          x = Object.assign(((m = {
        className: [c.label, g, j].join(" ").trim()
      })[f] = r[a] ? g : void 0, m.ref = v, m), N);

      return l.createElement(E || r, x, O);
    }

    return c[a] = !0, c.label = n.label ? n.label : "" + i + b, b++, l.forwardRef(c);
  };
}

var h = y(t),
    S = y(c);

function g() {
  var e = arguments[1] || {},
      r = e.css,
      t = e.className;
  void 0 === t && (t = "");

  var n = function (e, r) {
    var t = {};

    for (var n in e) {
      Object.prototype.hasOwnProperty.call(e, n) && -1 === r.indexOf(n) && (t[n] = e[n]);
    }

    return t;
  }(e, ["css", "className"]),
      a = s;

  if (r) {
    var c = r[u],
        i = c[0];
    c[1].forEach(function (e) {
      return a.createKeyframes(e);
    }), a.createStyles(r.toString(), i, void 0, r[o]), n.className = (r + " " + t).trim(), arguments[1] = n;
  }

  return l.createElement.apply(null, arguments);
}

export { m as Global, d as styled, S as keyframes, h as css, g as jsx };